import apiClient from '../utils/apiClient';

export async function createProject({
  client_name,
  client_company,
  project_name,
  email,
  phone_number,
  start_date,
  end_date,
  urgency,
  description,
  status_id,
  color,
  budget_cost,
  budget_hours,
  location,
  address
}) {
  const response = await apiClient.post('/api/projects/', {
    client_name,
    client_company,
    project_name,
    email,
    phone_number,
    start_date,
    end_date,
    urgency,
    description,
    status_id,
    color,
    budget_cost,
    budget_hours,
    location,
    address
  });

  return response.data;
}

export async function getProjects({ archived } = {}) {
  const params = {};
  if (archived) params.archived = 'true';
  const response = await apiClient.get('/api/projects/', { params });
  return response.data;
}

export async function updateProject(project_id, updatedFields) {
  const response = await apiClient.put(`/api/projects/${project_id}`, updatedFields);
  return response.data;
}

export async function getProjectStatuses() {
  try {
    const response = await apiClient.get('/api/projects/project-statuses');
    return response.data;
  } catch (error) {
    console.error("Error fetching project statuses:", error);
    throw error;
  }
}

export async function createProjectStatus({ name, color, description }) {
  const response = await apiClient.post('/api/projects/project-statuses', { name, color, description });
  return response.data;
}

export async function updateProjectStatus(statusId, { name, color, description }) {
  const response = await apiClient.put(`/api/projects/project-statuses/${statusId}`, { name, color, description });
  return response.data;
}

export async function deleteProjectStatus(statusId) {
  const response = await apiClient.delete(`/api/projects/project-statuses/${statusId}`);
  return response.data;
}

export async function reorderProjectStatuses(statusIds) {
  const response = await apiClient.put('/api/projects/project-statuses/reorder', { statusIds });
  return response.data;
}

export async function assignEmployeesToProject(projectId, payload) {
  const response = await apiClient.post(`/api/projects/${projectId}/assign`, payload);
  return response.data;
}

export async function getProjectAssignments(projectId) {
  const response = await apiClient.get(`/api/projects/${projectId}/assignments`);
  return response.data;
}

export async function createMilestone(projectId, milestone) {
  const response = await apiClient.post(`/api/projects/${projectId}/milestones`, milestone);
  return response.data;
}

export async function syncMilestones(projectId, milestones) {
  const response = await apiClient.put(`/api/projects/${projectId}/milestones`, { milestones });
  return response.data;
}

export async function getMilestones(projectId) {
  const response = await apiClient.get(`/api/projects/${projectId}/milestones`);
  return response.data;
}

export async function getAssignedMilestones(projectId, employeeId) {
  const response = await apiClient.get(`/api/projects/${projectId}/milestones/assigned/${employeeId}`);
  return response.data;
}

export async function assignEmployeesToMilestone(milestoneId, payload) {
  const response = await apiClient.post(`/api/projects/milestones/${milestoneId}/assignments`, payload);
  return response.data;
}

export async function updateMilestone(milestoneId, payload) {
  const response = await apiClient.put(`/api/projects/milestones/${milestoneId}`, payload);
  return response.data;
}

export async function getMilestoneAssignments(milestoneId) {
  const response = await apiClient.get(`/api/projects/milestones/${milestoneId}/assignments`);
  return response.data;
}

export async function deleteProject(projectId) {
  const response = await apiClient.delete(`/api/projects/${projectId}`);
  return response.data;
}

export async function getProjectBudget(projectId) {
  const response = await apiClient.get(`/api/projects/${projectId}/budget`);
  return response.data;
}

export async function updateProjectBudget(projectId, budgetData) {
  const response = await apiClient.put(`/api/projects/${projectId}/budget`, budgetData);
  return response.data;
}

export async function getProjectScheduledCosts(projectId) {
  const response = await apiClient.get(`/api/projects/${projectId}/scheduled-costs`);
  return response.data;
}

export async function getProjectActualCosts(projectId) {
  const response = await apiClient.get(`/api/projects/${projectId}/actual-costs`);
  return response.data;
}

// Export projects to CSV
export async function exportProjects(params = {}) {
    const response = await apiClient.get('/api/projects/export', {
        params,
        responseType: 'blob' // Important for file downloads
    });

    // Create download link
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `projects_export_${new Date().toISOString().split('T')[0]}.csv`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    return response.data;
}